var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleAlbumsSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4 4 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons:adjustments-horizontal"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    x: 4,
    y: 4,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#AC8D75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120",
    x: 4,
    y: 13,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#AC8D75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    x: 13,
    y: 4,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#AC8D75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 121",
    x: 13,
    y: 13,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#AC8D75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleAlbumsSvg);
export default __webpack_public_path__ + "static/media/MultipleAlbumsSVG.bd0a12af972ec381ad7115a81145394a.svg";
export { ForwardRef as ReactComponent };